// extracted by mini-css-extract-plugin
export var label = "Checkbox-module--label--7337z";
export var switcher = "Checkbox-module--switcher--X0qq8";
export var wrap = "Checkbox-module--wrap--3Ux6S";